<template>
    <v-dialog v-model="modal" :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" :width="width" scrollable>
        <v-card class="fondo-curso-modal">
            <v-toolbar class="cerrar" :height="heightCerrar" :color="colorBar">
                <v-spacer> </v-spacer>
                <button v-if="mostrarCerrar" @click="$emit('click', false), $emit('pausarAudio')" class="hvr hvr-scale">
                    <v-icon color="#FFFFFF">close</v-icon>
                </button>
            </v-toolbar>
            <v-card-text class="pa-2">
                <v-flex contain class="dialog-content" text-xs-center>
                    <slot name="modalcontent"></slot>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        model: {
            prop: 'modal',
            event: 'click'
        },
        props: {
            modal: Boolean,
            width: {
                type: String,
                default: '800px'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
            heightCerrar:{
                type: String,
                default: '45px'
            },
            colorBar:{
                type:String,
                default:'#0B542D'
            }
        },
        data() {
            return {
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../scss/helpers/variables';
    
    .cerrar {
        padding-bottom: 0;
        text-align: center;
        // background: #0B542D!important;
        box-shadow: none;
        flex: none;
        font-size: 1em!important;
        img{
            width: 30px;
        }
        h2{
            color: #FFFFFF;
        }

    }

    .dialog-content {
        max-width: 1100px;
        // max-width: 100%;
        margin: auto;
        font-size: 1rem;
        padding: 5px;
        margin-top: 0px;
        align-items: center;
        overflow: hidden;
        @media (max-height: 800px){
            align-items: start;
        }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal {
        background: #FFFFFF;
        border-radius: 7px;
    }
</style>
